/* Discount code entry for the cart drawer.
   Shopify exposes no AJAX endpoint for applying a code, so /discount/CODE is
   used to arm it for the session and the drawer is re-rendered from the
   cart-drawer section. Automatic discounts need none of this and always win
   on reliability - this is here because the design calls for a code field. */
(function () {
  function drawerHost() {
    return document.querySelector('cart-drawer');
  }

  async function refreshDrawer() {
    var host = drawerHost();
    if (!host) {
      window.location.reload();
      return;
    }
    var res = await fetch(window.Shopify.routes.root + '?section_id=cart-drawer&_=' + Date.now(), {
      cache: 'no-store',
    });
    var text = await res.text();
    var html = new DOMParser().parseFromString(text, 'text/html');
    var fresh = html.querySelector('cart-drawer .drawer__inner');
    var current = host.querySelector('.drawer__inner');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
    } else {
      window.location.reload();
    }
  }

  /* Chips for whatever codes the session carries. /cart.js is the only place
     that lists them, including ones that did not apply - Liquid never sees
     those, so the markup cannot be rendered server side. */
  var CLOSE_ICON =
    '<svg viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
    '<path d="M1 1l8 8M9 1l-8 8" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  async function paintCodes() {
    var host = document.querySelector('[data-aeloo-codes]');
    if (!host) return;
    var cart;
    try {
      cart = await (await fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' })).json();
    } catch (e) {
      return;
    }
    var codes = cart.discount_codes || [];
    host.hidden = codes.length === 0;
    host.innerHTML = codes
      .map(function (c) {
        var code = String(c.code).replace(/[&<>"]/g, '');
        return (
          '<span class="aeloo-cart__code' +
          (c.applicable ? '' : ' aeloo-cart__code--void') +
          '"><span class="aeloo-cart__code-text">' +
          code +
          '</span>' +
          (c.applicable ? '' : '<span class="aeloo-cart__code-note">not applicable</span>') +
          '<button type="button" class="aeloo-cart__code-remove" data-aeloo-remove-code="' +
          code +
          '" aria-label="Remove discount code ' +
          code +
          '">' +
          CLOSE_ICON +
          '</button></span>'
        );
      })
      .join('');
  }

  document.addEventListener('DOMContentLoaded', paintCodes);
  document.addEventListener('shopify:section:load', paintCodes);

  /* Removing a code. Shopify documents no endpoint for it, but /cart/update.js
     accepts a `discount` key and an empty value clears the session code. The
     result is read back rather than assumed, and anything left over falls back
     to a reload so the drawer can never show a code the cart no longer has. */
  document.addEventListener('click', async function (event) {
    var btn = event.target.closest('[data-aeloo-remove-code]');
    if (!btn) return;
    event.preventDefault();
    btn.setAttribute('aria-disabled', 'true');
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: '' }),
      });
      var check = await fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' });
      var cart = await check.json();
      if (cart.discount_codes && cart.discount_codes.length) {
        window.location.reload();
        return;
      }
      await refreshDrawer();
      await paintCodes();
    } catch (e) {
      window.location.reload();
    } finally {
      btn.removeAttribute('aria-disabled');
    }
  });

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('[data-aeloo-discount]');
    if (!form) return;
    event.preventDefault();

    var input = form.querySelector('input[name="aeloo-discount-code"]');
    var error = form.querySelector('.aeloo-cart__discount-error');
    var code = (input && input.value || '').trim();

    error.hidden = true;
    if (!code) {
      error.textContent = 'Please enter a discount code.';
      error.hidden = false;
      return;
    }

    form.classList.add('is-busy');
    try {
      await fetch('/discount/' + encodeURIComponent(code), {
        credentials: 'same-origin',
        redirect: 'follow',
      });
      await refreshDrawer();
      await paintCodes();
    } catch (e) {
      error.textContent = 'That code could not be applied.';
      error.hidden = false;
    } finally {
      form.classList.remove('is-busy');
    }
  });
})();
